var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66733 12.2921C10.2982 11.964 12.334 9.71977 12.334 7.00004C12.334 4.05452 9.9462 1.66671 7.00067 1.66671C4.05513 1.66671 1.66732 4.05452 1.66732 7.00004C1.66732 9.71977 3.70311 11.964 6.334 12.2921V8.33337H5.00065V7.00004H6.334V5.89724C6.334 5.00574 6.4268 4.68245 6.60113 4.35653C6.7754 4.0306 7.0312 3.77481 7.35713 3.60051C7.61226 3.46407 7.92873 3.38172 8.4818 3.3464C8.70126 3.33238 8.9854 3.35026 9.334 3.40004V4.66671H9.00067C8.38913 4.66671 8.1368 4.69559 7.98593 4.77626C7.8924 4.8263 7.82693 4.89176 7.77686 4.98533C7.6962 5.13616 7.66733 5.28573 7.66733 5.89724V7.00004H9.334L9.00067 8.33337H7.66733V12.2921ZM7.00067 13.6667C3.31875 13.6667 0.333984 10.6819 0.333984 7.00004C0.333984 3.31814 3.31875 0.333374 7.00067 0.333374C10.6825 0.333374 13.6673 3.31814 13.6673 7.00004C13.6673 10.6819 10.6825 13.6667 7.00067 13.6667Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.49ca4d975e5d70f62cd6109670ad6929.svg";
export { ForwardRef as ReactComponent };